import { useCallback } from "react";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { SearchByDetailLayout } from "../../../_shared";

import type * as Model from "../../model";

type Props = {
	title: string;
	options: Array<Model.Type.ReservationOption>;
	// 検索条件に追加
	onAddOption: (id: string) => void;
	// 検索条件から削除
	onRemoveOption: (id: string) => void;
};

export const SearchByReservationCondition = ({ title, options, onAddOption, onRemoveOption }: Props) => {
	/**
	 * チェックボックスの変更
	 */
	const onChangeChecked = useCallback(
		(id: string) => (checked: boolean) => {
			checked ? onAddOption(id) : onRemoveOption(id);
		},
		[onAddOption, onRemoveOption],
	);

	return (
		<div className="space-y-1">
			<p className="text-sm font-semibold">{title}</p>

			<SearchByDetailLayout>
				{options.map((option, index) => {
					const handleChangeChecked = onChangeChecked(option.id);
					return (
						<CheckboxField
							key={index}
							value={option.checked}
							label={option.label}
							handleChange={handleChangeChecked}
						/>
					);
				})}
			</SearchByDetailLayout>
		</div>
	);
};
